var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline-flex" },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "offset-y": "",
            left: "",
            "close-on-content-click": false,
            "max-width": "380",
            "min-width": "320",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b({ attrs: { icon: "" } }, "v-btn", attrs, false),
                      on
                    ),
                    [
                      _c(
                        "v-badge",
                        {
                          attrs: {
                            value: _vm.total_unread > 0,
                            content:
                              _vm.total_unread > 99 ? "99+" : _vm.total_unread,
                            color: "red",
                            overlap: "",
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-bell-outline")])],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.menu,
            callback: function ($$v) {
              _vm.menu = $$v
            },
            expression: "menu",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "py-2 subtitle-1" },
                [
                  _vm._v(" Notificaciones "),
                  _c("v-spacer"),
                  _vm.unread > 0
                    ? _c(
                        "v-btn",
                        {
                          attrs: { text: "", "x-small": "", color: "primary" },
                          on: { click: _vm.readAll },
                        },
                        [_vm._v("Marcar todas como leídas")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("v-divider"),
              _vm.news_in_menu.length > 0
                ? [
                    _c(
                      "v-list",
                      { staticClass: "py-0", attrs: { dense: "" } },
                      [
                        _c(
                          "v-subheader",
                          [
                            _vm._v(" Novedades "),
                            _c("v-spacer"),
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.openNews.apply(null, arguments)
                                  },
                                },
                              },
                              [_vm._v("Ver todas")]
                            ),
                          ],
                          1
                        ),
                        _vm._l(_vm.news_in_menu, function (item) {
                          return _c(
                            "v-list-item",
                            {
                              key: "news-" + item.id,
                              on: { click: _vm.openNews },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                    _c("v-divider"),
                  ]
                : _vm._e(),
              _vm.list.length == 0 && _vm.news_in_menu.length == 0
                ? _c("div", { staticClass: "pa-6 text-center grey--text" }, [
                    _vm._v("No tenés notificaciones."),
                  ])
                : _vm.list.length > 0
                ? _c(
                    "v-list",
                    {
                      staticStyle: {
                        "max-height": "420px",
                        "overflow-y": "auto",
                      },
                      attrs: { dense: "" },
                    },
                    _vm._l(_vm.list, function (item) {
                      return _c(
                        "v-list-item",
                        {
                          key: item.id,
                          class: { "blue lighten-5": !item.read },
                          on: {
                            click: function ($event) {
                              return _vm.open(item)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { class: { "font-weight-bold": !item.read } },
                                [_vm._v(_vm._s(item.title))]
                              ),
                              _c("div", { staticClass: "caption" }, [
                                _vm._v(_vm._s(item.body)),
                              ]),
                              _c("div", { staticClass: "caption grey--text" }, [
                                _vm._v(
                                  _vm._s(_vm.formatDateTime(item.creation_date))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c("NewsNotice", {
        attrs: {
          value: _vm.show_news_notice,
          count: _vm.news_count,
          latest: _vm.news_latest,
          marking: _vm.news_marking,
        },
        on: { read: _vm.markNewsRead, open: _vm.openNews },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }